import React from "react";
import { Card, CardBody, Table, Row, Col, Button } from "reactstrap";
import { Link } from "react-router-dom";
import avatar1 from "../../assets/images/users/avatar-1.jpg";
import avatar4 from "../../assets/images/users/avatar-1.jpg";
import avatar3 from "../../assets/images/users/avatar-1.jpg";
import avatar5 from "../../assets/images/users/avatar-1.jpg";
import avatar6 from "../../assets/images/users/avatar-1.jpg";
import { useSelector } from "react-redux";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import GoogleMark from "../../Components/Common/GoogleMark";
import GoogleDistance from "../../Components/Common/GoogleDistance";


const BotGrid = ({ onDelete_Bot }) => {
  const bot_list_data = useSelector((state) => state.Bot_List);
  const navigate = useNavigate();

  return (
    <React.Fragment>
      <div
     
        className="botgrid"
      >
        <Row className="row-cols-xxl-5 row-cols-lg-3 row-cols-1">
          {bot_list_data.botList.map((ele, i) => {
            const {
              Bot_ID,
              Bot_Title,
              Group_Name,
              Model,
              Type,
              BOT_Category,
              User_Role,
              Last_Active_Date_Time,
              Bot_Logo,
              Assets_ID
            } = ele;

            return (
              <Col key={Bot_ID} className="grid-wrap">
             {User_Role=='BotAdmin' && <span className="gbd" onClick={()=>{
                 onDelete_Bot(Bot_ID)
              }}> <i className="ri-delete-bin-line"></i></span>}
                <Card 


                  onClick={()=>{
                                        
                      navigate("/Configuration", {
                          state: {
                            Bot_ID,
                            Assets_ID
                          },
                        })
                    }
                      
                  }
                
              
                
                className="card-body">
                  <div 
                   
                  


                   
                   
                   className="d-flex mb-4 align-items-center">
                    <div className="flex-shrink-0">
                      <img
                        src={Bot_Logo}
                        alt=""
                        className="avatar-sm rounded-circle"
                      />
                    </div>
                    <div className="flex-grow-1 ms-2">
                      <h5 className="card-title mb-1">{Bot_Title}</h5>
                    </div>
                  </div>
                  <div className="grid_detail">
                    
                    <p className="card-text text-muted">{Model}</p>
                    <p className="card-text text-muted">{BOT_Category}</p>
                    <p className="card-text text-muted">{Type}</p>
                    <p className="card-text text-muted"> {Group_Name} </p>
                    <p className="card-text text-muted">
                      {Last_Active_Date_Time &&
                        moment(Last_Active_Date_Time).format("YYYY-MM-DD")}
                    </p>
                    <p className="card-text text-muted">
                    <span
                        className={`badge rounded-pill ${
                          User_Role === "BotAdmin"
                            ? "bg-primary-cust-button text-dark"
                            : User_Role === "Viewer"
                            ? "bg-warning-cust text-dark"
                            : User_Role === "BotUser"
                            ? "bg-info-subtle-cust text-dark"
                            : ""
                        }`}
                      >
                        {User_Role === "Viewer" ? "BotViewer" : User_Role}
                      </span>
                    </p>
                  </div>
                  {/* <Button
                    onClick={() => {
                      navigate("/Configuration", {
                        state: {
                          Bot_ID,
                        },
                      });
                    }}
                    color="primary"
                    className="btn-sm max-wf"
                  >
                    See Details
                  </Button> */}
                </Card>
              </Col>
            );
          })}
        </Row>
        
      </div>
    </React.Fragment>
  );
};

export default BotGrid;
